export const LOCALES = ['en', 'es'] as const
export type Locale = typeof LOCALES[number]
export const DEFAULT_LOCALE: Locale = 'es'
export const LOCALE_LABELS: Record<Locale, string> = { en: 'English', es: 'Español' }
export const LOCALE_FLAGS: Record<Locale, string> = { en: '🇺🇸', es: '🇪🇸' }
